/**
 *
 * Notify
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import Button from '../Button';

import style from './style.module.scss';

function Notify(props) {
  return (
    <div className={style.notification}>
      {props.header && <div className={style.header}>{props.header}</div>}
      <div className={`${style.notificationBox} ${style[props.notifyType] || style.success}`}>
        <div className={style['error-icon']}>
          <span className={`material-icons ${style['md-32']}`}>warning</span>
        </div>
        <div className={style.notifyheading}>{props.notifyheading}</div>
        <div className={style.notifyDescription}>
          {props.notifyDescription}
          {props.notifyCode && (
            <div className={style.notifyCode}>{props.notifyCode}</div>
          )}
        </div>
        <Button
          text={props.buttonText}
          onClick={props.buttonOnClick}
          className={props.buttonClass}
        />
      </div>
    </div>
  );
}

Notify.propTypes = {
  header: PropTypes.string,
  notifyType: PropTypes.string,
  notifyheading: PropTypes.string,
  notifyDescription: PropTypes.string,
  notifyCode: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  buttonClass: PropTypes.string,
  buttonOnClick: PropTypes.func.isRequired,
};

export default Notify;
